import { render, staticRenderFns } from "./ContentOfferingsBlock.vue?vue&type=template&id=4a27d06a&scoped=true"
import script from "./ContentOfferingsBlock.vue?vue&type=script&lang=js"
export * from "./ContentOfferingsBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentOfferingsBlock.vue?vue&type=style&index=0&id=4a27d06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27d06a",
  null
  
)

export default component.exports